module.exports = __webpack_public_path__ + "4c05e23a13621dc4aa125998a5378d01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dog-icon.png
// module id = 815
// module chunks = 0